const state = {
  pinTypes: [],
  regions: [],
  entities: [],
  entityTypes: [],
  tagItems: [],
  entityProfile: {}
}

export default state;